import React, { useState, useEffect } from "react";
import Header from "../../components/Header.js";
import axios from "axios";
import { Link } from "react-router-dom";

const Task = () => {
  const [customerIds, setcustomerIds] = useState("");
  const [dl, setDl] = useState("");
  const [unit, setUnit] = useState("");
  const [task_no, setTask_no] = useState("");
  const [units, setUnits] = useState([]);

  useEffect(() => {
    const generateTaskNo = () => {
      const today = new Date();
      const dateStr = today.getFullYear().toString().substring(2) + 
                      String(today.getMonth() + 1).padStart(2, "0") + 
                      String(today.getDate()).padStart(2, "0"); // YYMMDD
      const random = Math.floor(1000 + Math.random() * 9000); // 4-digit random
      return `REF-${dateStr}-${random}`;
    };
    setTask_no(generateTaskNo());

    const fetchUnits = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/units`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.success) {
          setUnits(response.data.data || []);
        }
      } catch (error) {
        console.error("Failed to fetch units:", error);
      }
    };

    fetchUnits();
  }, []);

  const handleRegisterTask = async () => {
    if (!customerIds) {
      alert("Please enter at least one Task ID");
      return;
    }

    const ids = customerIds.split(",").map((id) => id.trim());

    try {
      const token = localStorage.getItem("token");

      // Send the POST request with the token in the headers
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/register-task`,
        { customerIds: ids, dl: dl, unit: unit, task_no: task_no },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Add token to the request headers
          },
        }
      );

      if (response.status !== 200) {
        throw new Error(`Task not found`);
      }

      alert("Task registered succesfully!");
    } catch (error) {
      console.error("Error fetching tasks:", error);
      alert(error.message);
    }
  };

  return (
    <div className="flex h-screen">
      <div className="flex-1 overflow-auto">
        <Header title="Admin Dashboard" />
        <div className="p-6 pt-24">
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-2">
              IDPEL:
            </label>
            <input
              type="text"
              value={customerIds}
              onChange={(e) => setcustomerIds(e.target.value)}
              placeholder="Masukkan IDPEL"
              className="w-full max-w-md p-2 border border-gray-300 rounded-md focus:ring focus:ring-blue-300"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-2">
              Deadline:
            </label>
            <input
              type="date"
              value={dl}
              onChange={(e) => setDl(e.target.value)}
              className="w-full max-w-md p-2 border border-gray-300 rounded-md focus:ring focus:ring-blue-300"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-2">
              Unit:
            </label>
            <select
              value={unit}
              onChange={(e) => setUnit(e.target.value)}
              className="w-full max-w-md p-2 border border-gray-300 rounded-md focus:ring focus:ring-blue-300 bg-white"
            >
              <option value="">-- Pilih Unit Kerja --</option>
              {units.map((u) => (
                <option key={u.id} value={u.code}>
                  {u.name} ({u.code})
                </option>
              ))}
            </select>
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-2">
              Nomor Agenda Tugas:
            </label>
            <input
              type="text"
              value={task_no}
              readOnly
              placeholder="REF-YYMMDD-XXXX"
              className="w-full max-w-md p-2 border border-gray-300 rounded-md bg-slate-100 cursor-not-allowed font-mono text-slate-600 focus:outline-none"
            />
          </div>
          <div className="flex space-x-4">
            <button
              onClick={handleRegisterTask}
              className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
            >
              Register Tugas
            </button>
            <Link
              to="/histori-task"
              className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition"
            >
              Histori Tugas
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Task;
